export enum OptionType {
  Check = 1,
  Radio = 2,
}
